import { metaTag } from '@/types/interfaces';

const genericPageMeta: metaTag[] = [
  {
    name: 'MSM.Content.ChannelId',
    content: '334',
  },
  {
    name: 'MSM.Content.Vertical',
    content: 'money',
  },
  {
    name: 'MSM.Content.Product',
    content: 'credit club',
  },
  {
    name: 'MSM.Content.SubProduct',
    content: 'unclassified',
  },
  {
    name: 'MSM.Content.PageType',
    content: 'unclassified',
  },
  {
    name: 'MSM.Content.SubPageType',
    content: 'unclassified',
  },
  {
    name: 'MSM.Content.pageId',
    content: 'unclassified',
  },
  {
    name: 'MSM.Page.Template',
    content: 'unclassified',
  },
  {
    name: 'MSM.Page.Date',
    content: 'unclassified',
  },
];

const loginPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'log in',
  },
];

const dashboardPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'dashboard',
  },
];

const creditReportPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'report',
  },
];

const cardEligibilitySearchPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.SubProduct',
    content: 'credit cards',
  },
];

const cardEligibilityResultsPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.SubProduct',
    content: 'credit cards',
  },
  {
    name: 'MSM.Content.PageType',
    content: 'results page',
  },
];

const loanEligibilitySearchPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.SubProduct',
    content: 'loans',
  },
];

const loanEligibilityResultsPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.SubProduct',
    content: 'loans',
  },
  {
    name: 'MSM.Content.PageType',
    content: 'results page',
  },
];

const otherReportsPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'guide page',
  },
];

const otpAuthenticateChoicePageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'question page',
  },
  {
    name: 'MSM.Content.SubPageType',
    content: 'authenticate decision',
  },
];

const otpAuthenticateFailedPageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'result page',
  },
  {
    name: 'MSM.Content.SubPageType',
    content: 'authenticate fail',
  },
];

const otpAuthenticatePasscodePageMeta: metaTag[] = [
  ...genericPageMeta,
  {
    name: 'MSM.Content.PageType',
    content: 'question page',
  },
  {
    name: 'MSM.Content.SubPageType',
    content: 'authenticate passcode',
  },
];

export default {
  genericPageMeta,
  loginPageMeta,
  dashboardPageMeta,
  creditReportPageMeta,
  cardEligibilitySearchPageMeta,
  cardEligibilityResultsPageMeta,
  loanEligibilitySearchPageMeta,
  loanEligibilityResultsPageMeta,
  otherReportsPageMeta,
  otpAuthenticateChoicePageMeta,
  otpAuthenticateFailedPageMeta,
  otpAuthenticatePasscodePageMeta,
};
